import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';

import { filter } from 'rxjs';
import { map, switchMap, tap } from 'rxjs/operators';

import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';

import { AdministratorCompanyCRUDService, CompanyCRUDService, SettingCRUDService } from '@digitalforest/ngx-oak-api';

import { selectValidAdministrator } from './administrator.selector';
import { ScopeActions } from './scope.actions';

@Injectable()
export class ScopeEffects {
  private actions$: Actions = inject(Actions);
  loadCompanySuccess$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(ScopeActions.loadCompanySuccess),
        tap(() => console.debug('[ScopeEffects] loadCompanySuccess')),
      ),
    { dispatch: false },
  );
  unloadCompany$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ScopeActions.unloadCompany),
      tap(() => console.debug('[ScopeEffects] unloadCompany')),
      map(() => {
        localStorage.removeItem('company_id');
        return ScopeActions.unloadCompanySuccess();
      }),
    ),
  );
  unloadCompanySuccess$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(ScopeActions.unloadCompanySuccess),
        tap(() => console.debug('[ScopeEffects] unloadCompanySuccess')),
      ),
    { dispatch: false },
  );
  private router: Router = inject(Router);
  private store: Store = inject(Store);
  private companyCRUDService: CompanyCRUDService = inject(CompanyCRUDService);
  private settingCRUDService: SettingCRUDService = inject(SettingCRUDService);
  private administratorCompanyCRUDService: AdministratorCompanyCRUDService = inject(AdministratorCompanyCRUDService);

  loadCompany$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ScopeActions.loadCompany),
      tap(() => console.debug('[ScopeEffects] loadCompany')),
      switchMap(({ companyId }) =>
        this.store.pipe(
          selectValidAdministrator,
          map((administrator) => {
            return { administrator, companyId };
          }),
        ),
      ),
      switchMap(({ administrator, companyId }) =>
        this.companyCRUDService.manageGetCompany(companyId).pipe(
          map((company) => {
            return { administrator, company };
          }),
        ),
      ),
      switchMap(({ administrator, company }) =>
        this.settingCRUDService.manageGetSetting(company.company_setting_id, company.id).pipe(
          map((setting) => {
            return { administrator, company, setting };
          }),
        ),
      ),
      filter(({ administrator, company, setting }) => !!administrator && !!company && !!setting),
      switchMap(({ administrator, company, setting }) =>
        this.administratorCompanyCRUDService.manageGetAllAdministratorCompaniesByAdministratorAndCompany(administrator.id, company.id).pipe(
          map((administratorCompanyList) => administratorCompanyList[0]),
          map((administratorCompany) => {
            localStorage.setItem('company_id', company.id.toString());
            return ScopeActions.loadCompanySuccess({ company, setting, administratorCompany });
          }),
        ),
      ),
    ),
  );
}
